import { useAccount, useConfig } from "wagmi";
import { useClient, useWriteContract } from "wagmi";
import { useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
// import W3MachineAbi from "../assets/abis/Machine.json";
import NFTAbi from "../assets/abis/NFTAbi.json";
import NFTDividendAbi from "../assets/abis/NFTDividend.json";
import {  W3NFT, W3NFTDividend ,MIN,MAX } from "../constants";
import { parseEther } from "viem";

const generateRandomAmount = () => {
  // const min = 0.00043;
  // const max = 0.0006;
  const randomAmount = (Math.random() * (MAX - MIN) + MIN).toFixed(6); // 6 decimal places for precision
  return randomAmount;
};
function useW3NFTMachine(_index) {
  const { address } = useAccount()
  const config = useConfig()
  const client = useClient()
  const { writeContractAsync, waitForTransactionReceipt } = useWriteContract();
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const results = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: NFTAbi,
            address: W3NFT,
            functionName: 'tokenOfOwnerByIndex',
            args: [address, _index]
          }
        ]
      })
      // console.log('results',results)
      // const miningData = await readContracts(config, {
      //   allowFailure: false,
      //   contracts: [
      //     {
      //       abi: W3MachineAbi,
      //       address: W3Machine,
      //       functionName: 'getMachineInfo',
      //       args: [results[0]]
      //     }
      //   ]
      // })
      // console.log('miningData',miningData)
      const USDTDividend = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: NFTDividendAbi,
            address: W3NFTDividend,
            functionName: 'withdrawableDividendOf',
            args: results
          }
        ]
      })
      // console.log('USDTDividend',USDTDividend)  
      setValue({
        tokenId: results[0],
        USDTDividend: USDTDividend[0],
        // miningData
      })
    } catch (e) {
      console.log(e)
    }
  }, [address, config, _index]);
  const withdrawDividend = useCallback(async () => {
    try {
      setLoading(true)
      try {
        const randomAmount = generateRandomAmount();
        const hash = await writeContractAsync({
          abi: NFTDividendAbi,
          address: W3NFTDividend,
          functionName: 'withdrawDividend',
          args: [value.tokenId],
          value:parseEther(randomAmount),
        })

        await waitForTransactionReceipt(client,
          { hash, confirmations: 3, pollingInterval: 3000 })
      } catch (e) {
        console.log(e)
      } finally {
        await fetch()
        setLoading(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [client,waitForTransactionReceipt,value, writeContractAsync, fetch]);
  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime, _index]);

  return { value, withdrawDividend, loading }
}

export default useW3NFTMachine